import {
  HFD_FEF9_DONGLE_PRODUCT_ID,
  isHfdFef9DongleProductId,
  isHfdFef9DongleX75Gc,
} from "./hfdFef9Dongle";

/** HFD X75GC 的 VID+PID 列表（有线 + 2.4G） */
export const HFD_X75GC_VENDOR_PRODUCT: ReadonlyArray<{
  vendorId: number;
  productId: number;
  identifier: string;
}> = [
  { vendorId: 0x0c45, productId: 0x8802, identifier: "3141:34818:X75GC" }, // 有线（旧版 PID）
  { vendorId: 0x0c45, productId: 0x8803, identifier: "3141:34819:X75GC" }, // 有线（与 M98 8K 同 PID，靠名称区分）
  { vendorId: 0x0c45, productId: 0xfef9, identifier: "3141:65273:X75GC" }, // 2.4G
];

const HFD_X75GC_WIRED_PRODUCT_IDS = new Set([0x8802, 0x8803]);

export type HfdX75GcEquipmentLike = {
  vendorId?: number;
  productId?: number;
  keyboardType?: string;
  displayname?: string;
  productName?: string;
  solutionRovider?: string;
  identifier?: string;
};

function x75GcNameBlob(eq: HfdX75GcEquipmentLike): string {
  return `${eq.displayname ?? ""} ${eq.productName ?? ""} ${eq.keyboardType ?? ""}`;
}

function isX75GcNameBlob(nameBlob: string): boolean {
  return /\bx75\s*gc\b/i.test(nameBlob);
}

/** 是否为 HFD X75GC 设备 */
export function isHuafendaX75GcDevice(
  eq: HfdX75GcEquipmentLike | null | undefined
): boolean {
  if (!eq) return false;

  const pid = Number(eq.productId);
  if (pid === 0x8802) return true;

  const nameBlob = x75GcNameBlob(eq);
  if (isX75GcNameBlob(nameBlob)) return true;

  const kt = String(eq.keyboardType ?? "").trim();
  if (kt === "x75gc") return true;

  const id = String(eq.identifier ?? "").trim();
  const idLower = id.toLowerCase();
  if (id.includes("X75GC") || id.includes("34818")) return true;
  if (id.includes("34819") && idLower.includes("x75gc")) return true;
  if (pid === 0x8803 && idLower.includes("x75gc")) return true;

  if (isHfdFef9DongleX75Gc(eq)) return true;

  const vid = Number(eq.vendorId);
  if (!Number.isFinite(vid) || !id) return false;
  return HFD_X75GC_VENDOR_PRODUCT.some(
    (p) =>
      p.vendorId === vid &&
      (p.identifier === id || id.startsWith(`${p.identifier}:`))
  );
}

/** 是否为 HFD X75GC（展示名 / 配置表匹配） */
export function isHuafendaX75GcEquipment(
  eq: HfdX75GcEquipmentLike | null | undefined
): boolean {
  if (!eq || typeof eq !== "object") return false;
  const provider = String(eq.solutionRovider ?? "")
    .trim()
    .toLowerCase();
  if (provider && provider !== "huafenda") return false;
  return isHuafendaX75GcDevice(eq);
}

/** X75GC 有线（USB 0x8802 / 0x8803） */
export function isHuafendaX75GcWired(
  eq: HfdX75GcEquipmentLike | null | undefined
): boolean {
  const pid = Number(eq?.productId);
  return isHuafendaX75GcDevice(eq) && HFD_X75GC_WIRED_PRODUCT_IDS.has(pid);
}

/** X75GC 2.4G（接收器 0xfef9） */
export function isHuafendaX75GcWireless(
  eq: HfdX75GcEquipmentLike | null | undefined
): boolean {
  return isHuafendaX75GcDevice(eq) && isHfdFef9DongleProductId(eq?.productId);
}

export { HFD_FEF9_DONGLE_PRODUCT_ID };
